// Here we define defaults for email editor
import AppyColors from './AppyColors';

/** @var specificSiteDefaults siteDefaults **/
export default {
  components: {
  },
  pages: {
  },
  site: {
    navigation: {
      stepper: {
        circleButtonColor: 'appy-color gold',
        circleButtonTextColor: 'black'
      }
    },
    icons: {
      defaultSize: 19
    }
  }
}
